import ProductItem from "./ProductItem";

// ProductGrid
const ProductGrid = ({ filteredProducts, ...otherProps }) => (
  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
    {filteredProducts.map(product => (
      <ProductItem key={product.id} product={product} {...otherProps} />
    ))}
  </div>
);


export default ProductGrid;